__turbopack_context__.v({
  "cardAnimation": "Toddhq_cardAnimation",
  "fadeInUp": "Toddhq_fadeInUp",
  "headerAnimation": "Toddhq_headerAnimation",
  "sectionAnimation": "Toddhq_sectionAnimation",
});
